var _style, _path, _rect, _rect2, _rect3, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPatternsDefault(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Rahmen",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 110 106",
    style: {
      enableBackground: "new 0 0 110 106"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#B4CCDD;}\r\n\t.st1{fill:#FFFFFF;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M35,21v44h40V21H35z M73,63H37V23h36V63z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 39,
    y: 25,
    className: "st0",
    width: 10,
    height: 9
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 39,
    y: 52,
    className: "st0",
    width: 10,
    height: 9
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 61,
    y: 36,
    className: "st0",
    width: 10,
    height: 14
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M51,25v9h20v-9H51z M69,32H53v-5h16V32z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M51,52v9h20v-9H51z M69,59H53v-5h16V59z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M39,36v14h20V36H39z M57,48H41V38h16V48z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPatternsDefault);
export default __webpack_public_path__ + "static/media/patterns-default.9735275c8e51efec0dfc52c2791cd889.svg";
export { ForwardRef as ReactComponent };